'use client'

import FabricCanvasTool from "../fabrictool"
import { fabric } from "@/@corefabriccanvas/fabric/dist/fabric"
import { SvgIcons } from "../../svgIcons"
class Eraser extends FabricCanvasTool {
  configureCanvas(props) {
    this._canvas.freeDrawingBrush = new fabric.EraserBrush(this._canvas)
    this._canvas.freeDrawingBrush.width = props.lineWidth * 5
    this._canvas.isDrawingMode = true
    this._canvas.freeDrawingCursor = `url(${SvgIcons.getEraserCursor(props.lineWidth * 5)}) ${(props.lineWidth * 5) / 2} ${(props.lineWidth * 5) / 2}, crosshair`
  }
}

export default Eraser
